<script setup>
import { postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);

let formModel = ref({});
const formRef = ref();

const rules = reactive({
  name: [
    {
      required: true,
      message: "请输入角色名称",
      trigger: "blur",
    },
  ],
  code: [
    {
      required: true,
      message: "请输入角色编号",
      trigger: "blur",
    },
  ],
});

const handleAdd = () => {
  handleEdit({});
};

const handleEdit = (record) => {
  formModel.value = Object.assign({}, { ...record });
  open.value = true;
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
};

const handleConfirm = async () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/role", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="角色名称" name="name">
        <a-input v-model:value="formModel.name" placeholder="请输入角色名称" />
      </a-form-item>
      <a-form-item label="角色编号" name="code">
        <a-input v-model:value="formModel.code" placeholder="请输入角色编号" />
      </a-form-item>
      <a-form-item label="角色说明" name="description">
        <a-textarea
          v-model:value="formModel.description"
          placeholder="请输入角色说明"
          :autosize="{ minRows: 2, maxRows: 6 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
